import { type ContentBugReportBody, inquiryApi } from '@mathflat/domain/Inquiry'

class BugReportController {
  postErrorReportConcept = (data: ContentBugReportBody) =>
    inquiryApi.createContentBugReport('CONCEPT', data, { mp_event_name: 'T99-02_유형신고_API' })

  postErrorReportLittleChapter = (data: ContentBugReportBody) =>
    inquiryApi.createContentBugReport('LITTLE_CHAPTER', data, {
      mp_event_name: 'T99-02_유형신고_API',
    })

  postErrorReportPublicProblem = (data: ContentBugReportBody) =>
    inquiryApi.createContentBugReport('PUBLIC_PROBLEM', data, {
      mp_event_name: 'T99-02_시중문제신고_API',
    })

  postErrorReportCustomProblem = (data: ContentBugReportBody) =>
    inquiryApi.createContentBugReport('PROBLEM', data, { mp_event_name: 'T99-02_문제신고_API' })

  postErrorReportArithmetic = (data: ContentBugReportBody) =>
    inquiryApi.createContentBugReport('WORKSHEET', data, { mp_event_name: 'T99-02_학습지신고_API' })
}

export const bugReportController = new BugReportController()
